function validatorCleanErrors(form, formname) {
  formname = formname.toLowerCase()

  form.querySelectorAll(`.has-error [id^='${formname}'], .has-error [id*='-${formname}-']`).forEach((input) => {
    const group = input.closest('.has-error');
    const helpBlock = group.querySelector('.help-block');
    group.classList.remove('has-error');
    helpBlock.innerHTML = '';
    helpBlock.style.display = 'none';
  })
}

function validatorCollectErrors(namespace, errors) {
  const result = {};
  Object.keys(errors).forEach((name) => {
    const joined = `${namespace}[${name}]`;
    if (errors[name] instanceof Array) {
      result[joined] = errors[name];
    } else {
      const innerResult = validatorCollectErrors(joined, errors[name]);
      Object.keys(innerResult).forEach((innerName) => {
        result[innerName] = innerResult[innerName];
      });
    }
  });
  return result;
}

function validatorValidateForm(form, formname, errors) {
  validatorCleanErrors(form, formname);
  const errorsList = validatorCollectErrors(formname, errors);
  console.log(errorsList)
  Object.keys(errorsList).forEach((name) => {
    const input = form.querySelector(`[name="${name}"]`);
    const parent = input.closest('.form-group');
    if (parent) {
      parent.classList.add('has-error');
      const helpBlock = parent.querySelector('.help-block');

      if (helpBlock) {
        const errorsItems = errorsList[name];
        errorsItems.forEach((error) => {
          helpBlock.style.display = '';
          let listItem = document.createElement('div');
          listItem.innerText = error;
          helpBlock.appendChild(listItem)
        });
      }
    }
  });
}

